module.exports = __webpack_public_path__ + "static/media/instagram.e43a44b8.png";